<template>
  <div class="about">
    <umf-header style="position: absolute;"></umf-header>
    <div class="banner">
      <div class="row">
        <h4>
          <img src="~images/about/text.png"
               alt="">
        </h4>
      </div>
    </div>
    <div class="center-page">
      <div class="by"></div>
      <div id="boxFixed"
           class="nav-box clearfix"
           :class="{'is_fixed' : isFixed}">
        <div class="row">
          <ul>
            <li class="active">
              公司介绍
            </li>
            <li>团队介绍</li>
            <li>资质荣誉</li>
            <li>合作客户</li>
          </ul>
        </div>
      </div>
      <div class="page-box">
        
        <div class="page present" style="display:block">
          <div class="row">
            <h4 style="font-size: 28px;">鑫毅数科成立于2019年12月，由国内知名金融科技服务商的创始人和核心团队二次创业组建</h4>
            <h4>我们是一个懂金融业务的科技团队</h4>
            <h4>我们是一家为金融机构和实体经济提供数字化转型解决方案的公司</h4>
            <h4>我们信奉数字产生价值、科技洞见决策的经营理念</h4>
            <h4 style="line-height: 38px;">我司团队先后参与、承担中国互联网金融协会、中国支付清算协会的区块链、数字货币、监管科技等多项重点课题，完成了基于区块链的跨境保理融资授信管理平台（2018金融区块链创新应用优秀案例）、中国信通院区块链实时监控平台、广东金融局非现场监管区块链等系统研发和建设。</h4>
          </div>
        </div>
        <div class="page sm-two">
          <div class="row">
            <img src="../../assets/images/about/teamPersonnel.png" alt="">
          </div>
        </div>
        <div class="page sm-three">
          <div class="row">
            <img src="../../assets/images/about/zsAll.png" alt="">
          </div>
        </div>
        <div class="page sm-four">
          <div class="row">
            <img src="../../assets/images/about/cooperativeCustomers.png" alt="">
          </div>
        </div>

      </div>
    </div>
    <umf-footer></umf-footer>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { swiperAnimateCache, swiperAnimate } from "@/assets/js/swiper.animate1.0.3.min.js"
import 'swiper/dist/css/swiper.css'
import UmfHeader from '@/components/umfHeader'
import umfFooter from '@/components/umfFooter'
import vueSeamlessScroll from 'vue-seamless-scroll'
import $ from 'jquery'
export default {
  components: {
    UmfHeader,
    umfFooter,
    Swiper,
    SwiperSlide,
    vueSeamlessScroll
  },

  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  data () {
    return {
      isFixed: false,
      offsetTop: 0,
      id: '',
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        autoplay: 2000,
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
      }

    }
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id

    }
  },
  mounted () {
    window.addEventListener('scroll', this.initHeight);
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置 
      this.offsetTop = $('#boxFixed').offset().top;
    })
    if (this.id !== '') {
      $('.center-page .nav-box ul li').eq(this.id).addClass('active').siblings().removeClass('active')
      console.log('id是', this.id );
      
      if (this.id === 0) {
        $("body,html").animate({ scrollTop: $('.present').offset().top - 45 }, 500)
      }
      if (this.id === 1) {
        $("body,html").animate({ scrollTop: $('.sm-two').offset().top - 45 }, 500)
      }
      if (this.id === 2) {
        $("body,html").animate({ scrollTop: $('.sm-three').offset().top - 45 }, 500)
      }
      if (this.id === 3) {
        $("body,html").animate({ scrollTop: $('.sm-four').offset().top - 45 }, 500)
      }

    }

    let _this = this
    $('.center-page .nav-box ul li').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()

      if (index === 0) {
        $("body,html").animate({ scrollTop: $('.present').offset().top - 45 }, 500)
      }
      if (index === 1) {
        $("body,html").animate({ scrollTop: $('.sm-two').offset().top - 45 }, 500)
      }
      if (index === 2) {
        $("body,html").animate({ scrollTop: $('.sm-three').offset().top - 45 }, 500)
      }
      if (index === 3) {
        $("body,html").animate({ scrollTop: $('.sm-four').offset().top - 45 }, 500)
      }


      // $('.page-box .page').eq(index).fadeIn().siblings().fadeOut()
    })
  },
  methods: {
    initHeight () {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
.about {
  height: 100%;
  .banner {
    width: 100%;
    height: 510px;
    background-image: url(~images/about/banner.png);
    background-size: cover;
    position: relative;
    h4 {
      padding-top: 190px;
    }
  }

  .center-page {
    width: 100%;
    position: relative;
    padding-top: 70px;
    .by {
      position: absolute;
      top: 0;
      right: 0;
      width: 1200px;
      margin: 0 auto;
      img {
        position: absolute;
        top: 0;
        right: 200px;
        position: absolute;
        top: -71px;
        right: 87px;
        z-index: 2;
      }
    }
    
    @import "@/assets/css/common/table.scss";
  }
  .page {
    width: 100%;
    min-height: 100%;
    height: auto;
    position: relative;
    &.present {
      text-align: center;
    height: 410px;
    padding-top: 100px;
    background: #f3f3f7;
      h3 {
        text-align: center;
        font-size: 36px;
        font-weight: bold;
      }
      h4 {
        text-align: center;
        font-weight: normal;
        font-size: 18px;
        color: #898282;
        margin-top: 10px;
        margin-bottom: 35px;
      }
      p {
        &:first-child {
          padding-top: 20px;
        }
        text-align: center;
        color: #898282;
        font-size: 16px;
        line-height: 30px;
      }
      .videoClass {
        width: 800px;
        height: 450px;
        margin: 0 auto 50px auto;
        video {
          width: 800px;
          height: 450px;
        }
      }
    }
    &.sm-two {
      height: 760px;
      overflow: hidden;
      .row {
        padding-top: 50px;
      }
      .title {
        padding-top: 150px;
        text-align: center;
      }
      .icon {
        width: 50px;
        height: 50px;
        background-image: url(~images/about/dowm.png);
        background-size: 100% 100%;
        margin: 45px auto;
      }
      .bottom {
        background: #202020;
        width: 5000px;
        margin-left: 150px;
        padding: 50px 0;
        padding-right: 50px;
        padding-bottom: 60px;
        h3 {
          font-size: 35px;
          font-weight: normal;
          padding-left: 120px;
        }
        p {
          padding-left: 120px;
          color: #c2c2c2;
          font-size: 16px;
          line-height: 36px;
        }
      }
    }
    &.sm-three {
      text-align: center;
      background: #f3f3f7;
      height: 760px;
      padding-top: 50px;
      h3 {
        padding-top: 88px;
        text-align: center;
        font-size: 36px;
        font-weight: normal;
        color: #515259;
        margin-bottom: 30px;
      }
      dl {
        padding: 15px;
        cursor: pointer;
        margin-bottom: 20px;
        &:hover {
          box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.2);
        }
        dt {
          float: left;
          img {
            display: block;
          }
        }
        dd {
          float: left;
          width: 840px;
          padding-left: 60px;
          .title {
            height: 40px;
            h4 {
              padding-top: 15px;
              color: #000000;
              font-weight: bold;
              font-size: 18px;
              float: left;
              width: 700px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              height: 25px;
            }
            .time {
              float: right;
              color: #898282;
              font-size: 14px;
              padding-top: 18px;
              float: right;
              padding-right: 30px;
              font-weight: normal;
            }
          }

          p {
            line-height: 34px;
            font-size: 16px;
            color: #898282;
            padding-top: 15px;
            overflow: hidden;
            height: 60px;
            width: 100%;
          }
        }
      }
      .fenye {
        text-align: center;
        margin-top: 40px;
        ul {
          margin: 20px auto;
          li {
            display: inline-block;
            cursor: pointer;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            color: #a9a9a9;
            font-size: 14px;

            &.active {
              background: #6b6b6b;
              color: #ffffff;
            }
          }
        }
      }
    }
    &.sm-four {
      height: 760px;
      padding-top: 20px;
      .row {
        position: relative;
      }
      h3 {
        padding-top: 120px;
        text-align: center;
        font-size: 36px;
        font-weight: normal;
        color: #515259;
        margin-bottom: 50px;
      }
      .item {
        background: #ffffff;
        text-align: center;
        padding: 20px;
        .title {
          text-align: left;
          font-size: 16px;
          line-height: 20px;
          color: #2e2e30;
          padding-bottom: 15px;
          height: 40px;
        }
      }
      .link-box {
        width: 1200px;
        margin: 0 auto;
        margin-top: 50px;
        ul {
          padding-left: 50px;
          li {
            float: left;
            padding-left: 30px;
            position: relative;
            font-size: 16px;
            margin-right: 130px;
            color: #2e2e30;
            &:last-child {
              margin-right: 0px;
            }
            &::before {
              content: "";
              display: block;
              width: 18px;
              height: 18px;
              background: #d8d8db;
              border-radius: 50%;
              position: absolute;
              left: 0;
              top: 2px;
            }
          }
        }
      }
      .next {
        width: 44px;
        height: 44px;
        background-image: url(~images/about/right.png);
        outline: none;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 65%;
        z-index: 5;
      }
      .prev {
        width: 44px;
        height: 44px;
        background-image: url(~images/about/left.png);
        outline: none;
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 65%;
        z-index: 5;
      }
    }
  }
}
</style>

